import { render, staticRenderFns } from "./EditNewUser.vue?vue&type=template&id=3000971a&scoped=true&"
import script from "./EditNewUser.vue?vue&type=script&lang=js&"
export * from "./EditNewUser.vue?vue&type=script&lang=js&"
import style0 from "./EditNewUser.vue?vue&type=style&index=0&id=3000971a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3000971a",
  null
  
)

export default component.exports